import { Colors } from "../../../../utils/colors";
import { useTheme } from "../../../../hooks/useTheme";
import { useEffect, useMemo, useState } from "react";
import { Icon } from "@iconify/react";
import StandardBorderedContainer from "../../../Containers/StandardBorderedContainer";
import { useSelector } from "react-redux";
import { getAccountState } from "../../../../redux/slices/accountSlice";

type MassTextMediaAttachmentProps = {
  mediaUrl: string;
  removeImage?: () => void;
  noBottomPadding?: boolean;
};

// Shows the mass text media url (ie. image or contact card)
export const MassTextMediaAttachment = (
  props: MassTextMediaAttachmentProps
) => {
  const { mediaUrl, removeImage, noBottomPadding } = props;
  const { customer } = useSelector(getAccountState).account.accountData;
  const { theme } = useTheme();
  const [aspectRatio, setAspectRatio] = useState(1);

  // The stored contact card url carries a cache-busting query string that message copies may lack
  const isContactCard = useMemo(
    () =>
      !!mediaUrl &&
      !!customer.contactCardUrl &&
      mediaUrl.split("?")[0] === customer.contactCardUrl.split("?")[0],
    [mediaUrl, customer.contactCardUrl]
  );

  const styles = {
    coverImage: {
      marginTop: 24,
      marginBottom: 14,
      width: 260,
      borderRadius: 12,
      resizeMode: "cover",
    },

    coverImageIcon: {
      backgroundColor: theme.ButtonSecondaryBG.backgroundColor,
      width: 28,
      height: 28,
      borderRadius: 14,
      cursor: "pointer",
    },
  };

  useEffect(() => {
    if (mediaUrl && !isContactCard) {
      const img = new Image();
      img.onload = () => {
        setAspectRatio(img.width / img.height);
      };
      img.src = mediaUrl;
    }
  }, [isContactCard, mediaUrl]);

  return isContactCard ? (
    <StandardBorderedContainer
      containerStyles={{
        backgroundColor: Colors.WHITE1,
        padding: 14,
        borderRadius: 12,
        width: 217,
        display: "flex",
      }}
      className="AlignedRowSpaced"
    >
      <div className="AlignedRow" style={{ gap: 10 }}>
        <StandardBorderedContainer
          containerStyles={{
            borderRadius: 8,
            backgroundColor: Colors.WHITE,
            height: 37,
            width: 37,
            display: "flex",
          }}
          className="Centering"
        >
          <Icon
            icon="ion:id-card"
            height={20}
            style={{ color: Colors.BLACK }}
          />
        </StandardBorderedContainer>
        <span className="bodyMedium">Contact Card</span>
      </div>
      {removeImage ? (
        <Icon
          onClick={removeImage}
          icon="ion:close-circle"
          height={28}
          style={{ color: Colors.BLACK, cursor: "pointer" }}
        />
      ) : null}
    </StandardBorderedContainer>
  ) : (
    <div
      style={{ position: "relative", paddingBottom: noBottomPadding ? 0 : 120 }}
    >
      <img
        src={mediaUrl}
        alt={"text media"}
        style={{
          ...styles.coverImage,
          ...{ aspectRatio: aspectRatio },
        }}
      />
      {removeImage ? (
        <div
          className="Centering"
          style={{
            ...styles.coverImageIcon,
            ...{ position: "absolute", top: 34, left: 220 },
          }}
          onClick={removeImage}
        >
          <Icon
            icon={"ion:close-outline"}
            height={24}
            style={{ color: Colors.WHITE }}
          />
        </div>
      ) : null}
    </div>
  );
};
